import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import ForSale from "../views/forSale.vue";
import Sold from "../views/sold.vue";
import Sum from "../views/sum.vue";

const routes = [
  {
    path: "/",
    redirect: "Home",
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
  },
  {
    path: "/forSale",
    name: "ForSale",
    component: ForSale,
  },
  {
    path: "/Sold",
    name: "Sold",
    component: Sold,
  },
  {
    path: "/Sum",
    name: "Sum",
    component: Sum,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ "../views/About.vue");
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
